import React from 'react';
import PropTypes from 'prop-types';

import ProductCategory from './ProductCategory';

import styles from './index.scss';

const ProductCategoriesList = ({ categories, translationsMap }) => (
    <div className={styles.productCategories}>
        <div className={styles.productCategories__title}>
            {translationsMap['searchBox.inProductCategories']}
        </div>
        <ul className={styles.productCategories__list}>
            {categories.map((category, index) => (
                <ProductCategory key={`${index}-${category.text}`} category={category} />
            ))}
        </ul>
    </div>
);

ProductCategoriesList.propTypes = {
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.text,
            href: PropTypes.string.text,
        }),
    ).isRequired,
    translationsMap: PropTypes.object.isRequired,
};

export default ProductCategoriesList;
